import styled from 'styled-components'
import { themeGet } from 'styled-system'

export const TierLabelWrapper = styled.span`
  display: inline-block;
  background: ${({ color, theme }) =>
    color || themeGet('colors.aliceBlue')({ theme })};
  color: ${({ labelTextColor, theme }) =>
    labelTextColor || themeGet('colors.darkGray')({ theme })};
  border-radius: 6.25rem;
  padding: 0.375rem 1rem;
  font-size: 0.75rem;
  font-weight: 400;
  letter-spacing: 0.08em;
  line-height: 1;
  font-family: ${themeGet('font.molde.regular')};
  max-height: 0.75rem;
`
